export const SUBSCRIPTION_PAYMENT_FAILED_MESSAGE =
  "Your latest subscription payment failed. Please update or manage your subscription.";

export const SUBSCRIPTION_PAYMENT_FAILED_PATH = "/plans?payment=failed";
